import { parseExpiration } from "./expiration";

// Fluxo de avisos de pagamento (RSL - 060). A tela de planos deixou de ser um
// único bloqueio e virou uma escada, medida em dias de calendário a partir do
// vencimento (`planExpirationDate`, o último dia pago):
//
//   BANNER  teste em andamento, nos 5 primeiros dias de cadastro: só uma faixa
//           laranja no topo, que se dispensa com o "x".
//   SOFT    teste nos últimos dias, antes do vencimento: modal ao abrir o app,
//           com "Escolher plano depois" (dá para sair).
//   DUE     do dia do vencimento até 7 dias depois: modal "seu plano venceu"
//           sem "escolher depois"; dá para ir à tela de pagamento e sair dela.
//   HARD    7 dias ou mais depois do vencimento: modal fixo, sem saída — sair
//           da tela de pagamento sem pagar traz o modal de volta.
//   NONE    nada a avisar (plano pago em dia, ou sem dados para decidir).
//
// O teste dura 7 dias a partir do cadastro e o vencimento é gravado nessa conta
// (`companyService`/`companyController` no backend: hoje + 7 dias), então o dia
// do cadastro é derivado do vencimento.
export const PAYMENT_PHASE = {
  NONE: "none",
  BANNER: "banner",
  SOFT: "soft",
  DUE: "due",
  HARD: "hard",
};

export const TRIAL_DAYS = 7;
// Dias de cadastro em que a faixa aparece (dia do cadastro + 4 seguintes).
export const BANNER_DAYS = 5;
// Dias depois do vencimento em que o modal passa a ser fixo.
export const HARD_BLOCK_AFTER_DAYS = 7;

const DAY_MS = 24 * 60 * 60 * 1000;

const startOfLocalDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

// Dias de calendário entre hoje e o dia do vencimento: positivo antes do
// vencimento, 0 no dia, negativo depois. `null` sem data válida.
export const daysUntilDue = (expiration, now = new Date()) => {
  const due = parseExpiration(expiration);
  if (!due) return null;
  return Math.round((startOfLocalDay(due) - startOfLocalDay(now)) / DAY_MS);
};

/**
 * Em que degrau do fluxo de pagamento a empresa está.
 *
 * - `expiration`  vencimento do plano (o que a API devolve).
 * - `hasPlan`     já contratou um plano (fora do teste).
 * - `blocked`     bloqueio decidido por status quando não há data de vencimento
 *                 (sem data não dá para contar dias: mantém o rigor de antes).
 */
export const getPaymentPhase = ({
  expiration,
  hasPlan = false,
  blocked = false,
  now = new Date(),
} = {}) => {
  const days = daysUntilDue(expiration, now);

  if (days === null) {
    return blocked ? PAYMENT_PHASE.HARD : PAYMENT_PHASE.NONE;
  }

  if (days <= 0) {
    return -days >= HARD_BLOCK_AFTER_DAYS
      ? PAYMENT_PHASE.HARD
      : PAYMENT_PHASE.DUE;
  }

  // Plano pago em dia: sem avisos antes do vencimento.
  if (hasPlan) return PAYMENT_PHASE.NONE;

  // Teste: dia do cadastro = TRIAL_DAYS dias antes do vencimento.
  if (days > TRIAL_DAYS) return PAYMENT_PHASE.NONE; // teste estendido à mão
  return days > TRIAL_DAYS - BANNER_DAYS
    ? PAYMENT_PHASE.BANNER
    : PAYMENT_PHASE.SOFT;
};
